'use strict';

/**
 * Collection of scripts related with the review cart modal.
 */
var reviewCart = {};

// Constants
var SELECTOR = {
    MODAL: '#com-modal--review-cart'
};

/**
 * Show the review cart modal.
 */
function show() {
    // Constants
    const $MODAL = $(SELECTOR.MODAL);

    if ($MODAL.length === 0) {
        return;
    }

    $MODAL.modal('show');
}

/**
 * Collection of event listeners related with modals.
 */
var modalEventListeners = {
    /**
     * Attach an event listener on hidding the review cart modal.
     */
    onHide: function () {
        // Constants
        const $MODAL = $(SELECTOR.MODAL);

        if ($MODAL.length === 0) {
            return;
        }

        $MODAL.on('hidden.bs.modal', function () {
            window.location.reload();
        });
    }
};

/**
 * Collection of custom event listeners.
 */
var customEventListeners = {
    /**
     * Attach an event listener for opening the review cart modal.
     */
    show: function () {
        $('body').on('com:modal.show.reviewCart', function () {
            show();
        });
    }
};

/**
 * Attach every event listener related with the review cart modal to the DOM.
 */
function attachEventListeners() {
    modalEventListeners.onHide();
    customEventListeners.show();
}

/**
 * Expose functions
 */
reviewCart.attachEventListeners = attachEventListeners;

module.exports = reviewCart;
